import { useContext } from "react";

import {
  ListenerDataContext,
  ListenerDataContextData,
} from "../contexts/ListenerData";

export function useListenerData(): ListenerDataContextData {
  const context = useContext(ListenerDataContext);

  if (!context) {
    throw new Error("useListenerData must be used within an AuthProvider");
  }

  return context;
}
